import { Link } from 'react-router-dom';
import { Button, CircularProgress, TableCell } from '@mui/material';

type TypeProps = {
  label?: string;
  to: string;
  isLoading?: boolean;
  onClick: () => void;
};

export const ViewLink = ({ label = 'View', isLoading = false, to, onClick }: TypeProps) => {
  return (
    <TableCell size='small' align='right'>
      <Link to={to}>
        <Button variant='contained' onClick={onClick} disabled={isLoading}>
          {isLoading ? <CircularProgress color='inherit' /> : label}
        </Button>
      </Link>
    </TableCell>
  );
};
